import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { faCompass, faHandshake, faLightbulb } from '@fortawesome/free-solid-svg-icons';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
  
})
export class AboutComponent implements OnInit {
  faLightbulb = faLightbulb;
  faCompass = faCompass;
  faHandshake = faHandshake;

  constructor(private dataService: DataService, private router: Router) { }
  categoryCount;
  ngOnInit(): void {
    this.dataService.groupCount$.subscribe(res => {
      this.categoryCount = res;
    })
  }

  goTo(route: string): void {
    this.router.navigate(['', route]);
  }
}
